import { render } from "./PrivacyInfo.vue?vue&type=template&id=c3dde6b0"
import script from "./PrivacyInfo.vue?vue&type=script&lang=js"
export * from "./PrivacyInfo.vue?vue&type=script&lang=js"

import "./PrivacyInfo.vue?vue&type=style&index=0&id=c3dde6b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__